import { Select } from 'antd';
import { useState } from 'react';

type Role = {
  uuid: string;
  name: string;
};

type TagsSelectProps = {
  rolesData: Role[];
  selectedValue?: string | string[];
  updateSelectValue: (value: string[]) => void;
  disabled?: boolean;
};

const TagsSelect = ({
  rolesData,
  selectedValue,
  updateSelectValue,
  disabled,
}: TagsSelectProps) => {
  const [open, setOpen] = useState(false);
  const { Option } = Select;

  const handleChange = (value: any) => {
    updateSelectValue(value.slice(-1));
  };

  return (
    <Select
      mode="tags"
      open={open}
      onDropdownVisibleChange={setOpen}
      onSelect={() => setOpen(false)}
      value={selectedValue}
      defaultValue={selectedValue}
      onChange={handleChange}
      placeholder="Select an option"
      style={{ width: 150 }}
      disabled={disabled}
    >
      {rolesData?.map((role: any) => (
        <Option key={role.uuid} value={role.name}>
          {role.name}
        </Option>
      ))}
    </Select>
  );
};

export default TagsSelect;
